import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { UserProfile } from '../../../model/src/lib/user-profile.model';
import { DetectRouteService } from '../services/detect-route.service';
import { StorageService } from '../services/storage.service';
import { AppConfig } from './../../config/app.config';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private detectRouteService: DetectRouteService,
    private appConfig: AppConfig
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser: UserProfile =
      this.storageService.local.getItem(this.storageService.keys.UserProfile) ||
      this.storageService.session.getItem(this.storageService.keys.UserProfile);
    const idToken: string =
      this.storageService.local.getItem(this.storageService.keys.IdToken) ||
      this.storageService.session.getItem(this.storageService.keys.IdToken);
    const companyId = this.detectRouteService.getCurrentRouteCompanyId();
    request = request.clone({
      setHeaders: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Methods':
          'GET, PUT, POST, DELETE, OPTIONS, PATCH',
        'Access-Control-Max-Age': '86400',
        'X-From-Channel': 'Web',
        'X-Client-TraceId': uuidv4(),
        'X-Client-Date': new Date().toISOString(),
        ...(currentUser &&
          currentUser.userNo && {
            'X-UserNo': currentUser.userNo,
          }),
        ...(currentUser &&
          currentUser.email && {
            Username: currentUser.email,
          }),
        ...(companyId && { 'X-CompanyId': companyId }),
        ...(this.appConfig.getAzureAD().enabled &&
          idToken && {
            Authorization: `Bearer ${idToken}`,
          }),
      },
    });
    return next.handle(request);
  }
}
